import { render, staticRenderFns } from "./AccountDetailsView.vue?vue&type=template&id=4a0ba574&scoped=true&"
import script from "./AccountDetailsView.vue?vue&type=script&lang=js&"
export * from "./AccountDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetailsView.vue?vue&type=style&index=0&id=4a0ba574&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0ba574",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBreadcrumbs,VCard,VIcon,VTab,VTabItem,VTabs})
